import React from 'react';

export const limitationOfLiabilityMessages = {
  value: 'Limitation of Liability',
  list: [
    {
      value: (
        <>
          Without prejudice to the above and subject to the applicable laws, the
          aggregate liability of Glints to any user for all claims arising from
          or relating to his/her use of Glints services and the Site shall be
          limited to the fees received by Glints in respect of the services
          giving rise to such claims.
        </>
      ),
    },
  ],
};
